// import { computeHeadingLevel } from '@testing-library/react';
import React, {Component} from "react";
import Jsoneditor from "../JsonEditor/JsonEditor";
import "./AddCountry.css";

class AddCountry extends Component {
  render() {
    console.log(this.props);
    return (
      <Jsoneditor
        updatedJson={this.props.updatedJson}
        countryId={this.props.countryId}
      />
    );
  }
}

export default AddCountry;
